import React from 'react';
import { Image } from 'react-konva';
const pipeInsertaTeeImgSrc = require('../../../../media/pipes/PipeAccessories/pipe-insertaTee.png');

/* instantiate the image */
const image = new window.Image();
image.src = pipeInsertaTeeImgSrc;

export default class PipeInsertaTeeComponent extends React.Component {
  render() {
      return (
        <Image
          image={image}
          x={this.props.x}
          y={this.props.y}
          height={this.props.diameter}
          rotation={this.props.rotation}
          width={this.props.diameter*2.5}
        />
      );
  }
}



// WEBPACK FOOTER //
// ./src/components/Drawings/Pipes/PipeAccesories/pipe-insertaTee.component.js